export interface AccountWorkRegion {
  WorkRegionId: string;
  WorkRegionCode: string;
  WorkRegionName: string;
  WorkRegionParentCode: string;
}
